import { useIntl } from 'react-intl';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';
import { Modal } from '@/shared/ui';

import { ModalID, modalModel } from '@/entities/modal';

import { OrderReport } from '@/widgets/OrderReport';

import styles from './MobileOrderReportModal.module.scss';

export const MobileOrderReportModal = () => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const { visible } = useAppSelector(
    (state) => state.modal[ModalID.MobileOrderReportModal],
  );

  const handleClose = () => {
    dispatch(modalModel.actions.closeModal(ModalID.MobileOrderReportModal));
  };

  return (
    <Modal
      data-component="mobile-order-report-modal"
      title={formatMessage({
        id: 'orderReport.title',
        defaultMessage: 'Create AI report',
      })}
      isOpen={visible}
      onCancel={handleClose}
      className={styles.container}
      headerClassName={styles.header}
      bodyClassName={styles.body}
      hideFooter
    >
      <OrderReport modal />
    </Modal>
  );
};
